import React from 'react';
import PropTypes from 'prop-types';
import { InfoRowWrapper } from './styled';
import QuestionDomain from '../top-problem-questions/question-domain';

const InfoRow = ({ i18n, question, topic, percentage, showStudentLJ }) => (
  <InfoRowWrapper showStudentLJ={showStudentLJ}>
    <span>{question}</span>
    <QuestionDomain domainName={topic} modalWidth={150} />
    <span>
      {showStudentLJ ? '' : `${100 - percentage}%`}&nbsp;
      <span role="img" aria-label={i18n.t`incorrect`}>&#10006;</span>
    </span>
  </InfoRowWrapper>
);

InfoRow.propTypes = {
  i18n: PropTypes.object,
  question: PropTypes.string,
  topic: PropTypes.string,
  percentage: PropTypes.number,
  showStudentLJ: PropTypes.bool
};

export default InfoRow;
